export enum AnswerFormat {
  OVERVIEW = "overview",
  EMAIL = "email",
}

export const ANSWER_FORMAT_OPTIONS: {
  value: AnswerFormat
  label: string
  description: string
}[] = [
  {
    value: AnswerFormat.OVERVIEW,
    label: "Overview",
    description:
      "Heading, brief intro, and clear bullet points — suited for product overviews and slides",
  },
  {
    value: AnswerFormat.EMAIL,
    label: "Email",
    description:
      "Professional email with Context, Key findings, Recommendation, Closing, and optional table",
  },
]
